<template>
  <div class="message-list-container">
    <h2>留言管理</h2>
    <div class="header-actions">
      <router-link to="/app/parser" v-if="authority === '1' || authority === '2'" class="action-btn">📥 导入数据</router-link>
    </div>
    <div class="filter-bar">
      <el-input v-model="messagePhone" placeholder="请输入联系方式" style="max-width: 200px"></el-input>
      <el-select
        v-model="projectNameSelect"
        filterable
        placeholder="请输入项目名称"
        style="width: 200px; margin-right: 12px;"
        :filter-method="filterProjectName"
      >
        <el-option v-for="item in filteredProjectNames" :key="item" :label="item" :value="item" />
      </el-select>
      <el-select
          v-model="mediaNameSelect"
          filterable
          placeholder="请输入媒体名称"
          style="width: 200px; margin-right: 12px;"
      >
        <el-option
            v-for="item in mediaNames"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        />
      </el-select>

      <el-select
        v-model="dateQuick"
        placeholder="快捷日期"
        style="width: 120px; margin-right: 12px;"
        @change="handleQuickDate"
      >
        <el-option label="今天" value="today" />
        <el-option label="昨天" value="yesterday" />
        <el-option label="近7天" value="last7days" />
        <el-option label="自定义" value="custom" />
      </el-select>
      <el-date-picker
        v-model="dateRange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期时间"
        end-placeholder="结束日期时间"
        style="width: 320px; margin-right: 12px;"
        value-format="yyyy-MM-dd HH:mm:ss"
        format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptions"
      />
      <div class="data-layout">
        <el-button @click="setToday">今天</el-button>
        <el-button @click="prevDay">前一天</el-button>
        <el-button @click="nextDay">后一天</el-button>
      </div>
      <el-button type="primary" icon="el-icon-search" @click="onQuery">查询</el-button>
    </div>
    <el-table :data="messages" border style="width: 100%" class="center-table"
        :header-cell-style="{ background: '#f5f7fa', color: '#333', fontWeight: 'bold', textAlign: 'center', fontSize: '16px'}"
        :max-height="600">
      <el-table-column type="index" label="序号" width="80" align="center"/>
      <el-table-column prop="projectName" label="项目名称" align="center"/>
      <el-table-column prop="messageName" label="姓名" align="center"/>
      <el-table-column prop="messagePhone" label="联系方式" align="center"/>
      <el-table-column prop="messageAddress" label="地址" align="center"/>
      <el-table-column prop="mediaName" label="媒体" align="center"/>
      <el-table-column prop="messageTime" label="时间" align="center">
        <template slot-scope="scope">
          {{ formatTime(scope.row.messageTime) }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" v-if="authority === '1' || authority === '2'">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">
              删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="table-pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="currentPage"
        :page-size=10
        :page-sizes="[10, 20, 40, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="handlePrevClick"
        @next-click="handleNextClick"
      />
    </div>

    <!--<table class="message-table">
      <thead>
        <tr>
          <th>序号</th>
          <th>项目名称</th>
          <th>姓名</th>
          <th>联系方式</th>
          <th>时间</th>
          <th>地址</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="7">正在加载...</td>
        </tr>
        <tr v-if="!loading && messages.length === 0">
          <td colspan="7">暂无数据</td>
        </tr>
        <tr v-for="(msg, idx) in messages" :key="msg.id || idx">
          <td>{{ (page - 1) * pageSize + idx + 1 }}</td>
          <td>{{ msg.projectName }}</td>
          <td>{{ msg.messageName }}</td>
          <td>{{ msg.messagePhone }}</td>
          <td>{{ formatTime(msg.messageTime) }}</td>
          <td>{{ msg.messageAddress }}</td>
          <td>
            <button class="action-btn danger" @click="openDeleteDialog(msg)">删除</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="table-pagination-bar">
      <span class="table-count-bottom">
        共{{ total }}条数据 | 第{{ page }} / {{ totalPages }}页
      </span>
      <button class="page-arrow" :disabled="page <= 1" @click="goPrevPage">
        <i class="el-icon-arrow-left"></i>
      </button>
      <button class="page-arrow" :disabled="page >= totalPages" @click="goNextPage">
        <i class="el-icon-arrow-right"></i>
      </button>
    </div>-->
     
    <!-- 删除确认弹窗 -->
    <div v-if="showDeleteDialog" class="dialog-mask">
      <div class="dialog-box delete-confirm-box">
        <h3>确认删除</h3>
        <div class="delete-confirm-content">确定要删除留言 <b>{{ deleteTarget.messagePhone }}</b> 吗？</div>
        <div class="dialog-actions">
          <button class="action-btn danger" @click="handleDeleteConfirm" :disabled="deleteLoading">{{ deleteLoading ? '删除中...' : '确认' }}</button>
          <button class="action-btn" @click="showDeleteDialog = false">取消</button>
        </div>
        <div v-if="deleteError" class="add-error">{{ deleteError }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MessageList',
  data() {
    return {
      messages: [],
      loading: false,
      messagePhone: '',
      projectNameSelect: '全部项目',
      projectName: '',
      dateQuick: 'today',
      dateRange: [],
      page: 1,
      total: 0,
      totalPages: 1,
      pageSize: 10,
      isFiltered: false,
      allProjectNames: [],
      projectNameFilter: '',
      showDeleteDialog: false,
      deleteTarget: {},
      deleteLoading: false,
      deleteError: '',
      currentPage: 1,
      tableData: [
        { id: 1, name: "项目A", status: "进行中" },
        { id: 2, name: "项目B", status: "已完成" },
        { id: 3, name: "项目C", status: "未开始" },
        { id: 4, name: "项目D", status: "进行中" },
        { id: 5, name: "项目E", status: "已完成" },
        { id: 6, name: "项目F", status: "未开始" },
        { id: 7, name: "项目B", status: "已完成" },
        { id: 8, name: "项目C", status: "未开始" },
        { id: 9, name: "项目D", status: "进行中" },
        { id: 10, name: "项目E", status: "已完成" },
        { id: 11, name: "项目F", status: "未开始" },
        { id: 12, name: "项目B", status: "已完成" },
        { id: 13, name: "项目C", status: "未开始" },
        { id: 14, name: "项目D", status: "进行中" },
        { id: 15, name: "项目E", status: "已完成" },
        { id: 16, name: "项目F", status: "未开始" },
        // ...更多数据
      ],
      pickerOptions1: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const start = new Date();
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const start = new Date();
              start.setDate(start.getDate() - 1);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setDate(end.getDate() - 1);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '前天',
            onClick(picker) {
              const start = new Date();
              start.setDate(start.getDate() - 2);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setDate(end.getDate() - 2);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              const start = new Date();
              start.setDate(start.getDate() - 7);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              const start = new Date();
              start.setMonth(start.getMonth() - 1);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              const start = new Date();
              start.setFullYear(start.getFullYear() - 1);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      authority: "",
      mediaNameSelect: 0,
      mediaNames: [],
    }
  },
  created() {
    this.initDate();
    this.fetchMessages();
    this.fetchAllProjectNames();
    this.fetchAllMediaNames();
  },
  methods: {
    initDate() {
      const today = new Date();
      const format = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 00:00:00`;
      const now = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 23:59:59`;
      this.dateRange = [format(today), now(today)];
    },
    handleQuickDate(val) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      let start, end;
      const format = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 00:00:00`;
      const endFormat = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 23:59:59`;
      switch(val) {
        case 'today':
          start = format(today);
          end = endFormat(today);
          break;
        case 'yesterday':
          var yest = new Date(today);
          yest.setDate(yest.getDate() - 1);
          start = format(yest);
          end = endFormat(yest);
          break;
        case 'last7days':
          var last7 = new Date(today);
          last7.setDate(last7.getDate() - 6);
          start = format(last7);
          end = endFormat(today);
          break;
      }
      this.dateRange = [start, end];
    },
    async fetchMessages(page = 1) {
      this.loading = true;
      try {
        // 获取用户信息
        const userInfoRes = await axios.get('/api/user/info');
        const userInfo = userInfoRes.data;
        this.authority = userInfo.authority;
        const employeeId = userInfo.employeeId;
        
        const pageSize1 = this.pageSize;
        let url;
        if (this.authority == 1) {
          url = `/api/messages/allPaged?page=${page}&pageSize=${pageSize1}`;
        } else {
          url = `/api/messages/allPagedWithEmployee?employeeId=${employeeId}&page=${page}&pageSize=${pageSize1}`;
        }
        const res = await axios.get(url);
        this.messages = res.data.data || [];
        this.total = res.data.total || 0;
        this.totalPages = res.data.totalPages || 1;
        this.page = page;
        if (this.messages.length > 0 && this.totalPages > 0) {
          this.pageSize = Math.ceil(this.total / this.totalPages);
        }
      } finally {
        this.loading = false;
      }
    },
    async onQuery() {
      this.page = 1;
      this.isFiltered = true;
      await this.reloadCurrentPage();
    },
    async goPrevPage() {
      if (this.page <= 1) return;
      this.page--;
      await this.reloadCurrentPage();
    },
    async goNextPage() {
      if (this.page >= this.totalPages) return;
      this.page++;
      await this.reloadCurrentPage();
    },
    async reloadCurrentPage() {
      if (this.isFiltered) {
        // 查询条件分页
        console.log("this.mediaNameSelect：", this.mediaNameSelect);
        const params = {
          phone: this.messagePhone || null,
          projectName: this.projectNameSelect == "全部项目" ? "" : this.projectNameSelect || null,
          media: this.mediaNameSelect,
          startDate: this.dateRange[0] ? this.dateRange[0].replace(' ', 'T') : null,
          endDate: this.dateRange[1] ? this.dateRange[1].replace(' ', 'T') : null,
          page: this.page,
          pageSize: this.pageSize
        };
        console.log(params);
        this.loading = true;
        try {
          console.log(params);
          // 获取用户信息
          const userInfoRes = await axios.get('/api/user/info');
          const userInfo = userInfoRes.data;
          this.authority = userInfo.authority;
          const employeeId = userInfo.employeeId;
          
          let url;
          if (this.authority == 1) {
            url = `/api/messages/queryByProjectTimeWithPhone`;
          } else {
            url = `/api/messages/queryByProjectTimeWithEmployeeAndPhone?employeeId=${employeeId}`;
          }
          const res = await axios.post(url, params);
          this.messages = Array.isArray(res.data.data) ? res.data.data : [];
          this.total = res.data.total || this.messages.length;
          this.totalPages = res.data.totalPages || 1;
          this.page = res.data.page || this.page;
        } finally {
          this.loading = false;
        }
      } else {
        // 默认分页
        await this.fetchMessages(this.page);
      }
    },
    formatTime(time) {
      if (!time) return '';
      const d = new Date(time);
      const y = d.getFullYear();
      const m = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      const h = d.getHours().toString().padStart(2, '0');
      const min = d.getMinutes().toString().padStart(2, '0');
      // const s = d.getSeconds().toString().padStart(2, '0');
      // return `${y}-${m}-${day} ${h}:${min}:${s}`;
      return `${y}-${m}-${day} ${h}:${min}`;
    },
    async fetchAllProjectNames() {
      try {
        // 获取用户信息
        const userInfoRes = await axios.get('/api/user/info');
        const userInfo = userInfoRes.data;
        this.authority = userInfo.authority;
        const employeeId = userInfo.employeeId;
        
        let url;
        if (this.authority == 1) {
          url = `/api/projects`;
        } else {
          url = `/api/projects/byEmployee?employeeId=${employeeId}`;
        }
        const res = await axios.get(url);
        this.allProjectNames = (res.data.data || []).map(p => p.name);
        // 判断是否包含"全部"，如果没有就添加
        if (!this.allProjectNames.includes("全部")) {
          this.allProjectNames.unshift("全部项目"); // 放在最前面
        }
      } catch (e) {
        this.allProjectNames = [];
      }
    },
    async fetchAllMediaNames() {
      try {
        const url = `/api/media`;
        const res = await axios.get(url);

        console.log(res);
        // 提取 name 和 type
        this.mediaNames = (res.data || []).map(p => ({
          label: p.name,
          value: p.id
        }));

        // 判断是否包含 "全部"，如果没有就添加
        const hasAll = this.mediaNames.some(item => item.label === "全部媒体");
        if (!hasAll) {
          this.mediaNames.unshift({ label: "全部媒体", value: 0 });
        }
      } catch (e) {
        this.mediaNames = [];
      }
    },
    filterProjectName(query) {
      this.projectNameFilter = query;
    },
    openDeleteDialog(msg) {
      this.deleteTarget = msg;
      this.deleteError = '';
      this.showDeleteDialog = true;
    },
    async handleDeleteConfirm() {
      this.deleteError = '';
      this.deleteLoading = true;
      try {
        await axios.post('/api/messages/delete', { id: this.deleteTarget.id });
        this.showDeleteDialog = false;
        await this.reloadCurrentPage();
      } catch (e) {
        this.deleteError = '删除失败，请稍后重试';
      } finally {
        this.deleteLoading = false;
      }
    },
    // 每页数量变化
    async handleSizeChange(newSize) {
      this.pageSize = newSize;
      console.log(newSize);
      this.currentPage = 1; // 切换条数后回到第一页
      this.page = 1;
      await this.reloadCurrentPage();
    },
    // 页码变化
    async handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.page = newPage;
      await this.reloadCurrentPage();
    },
    // 上一页点击
    async handlePrevClick(newPage) {
      this.page = newPage;
      await this.reloadCurrentPage();
    },
    // 下一页点击
    async handleNextClick(newPage) {
      this.page = newPage;
      await this.reloadCurrentPage();
    },
    handleDelete(index, row) {
      this.openDeleteDialog(row);
    },
    setToday () {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      let start, end;
      const format = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 00:00:00`;
      const endFormat = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 23:59:59`;
      start = format(today);
      end = endFormat(today);
      this.dateRange = [start, end];
    },
    prevDay () {
      let startDate = this.dateRange && this.dateRange.length > 0
          ? new Date(this.dateRange[0])
          : new Date(); // 如果没选过，默认今天
      let endDate = this.dateRange && this.dateRange.length > 0
          ? new Date(this.dateRange[1])
          : new Date(); // 如果没选过，默认今天

      const format = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 00:00:00`;
      const endFormat = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 23:59:59`;

      startDate.setDate(startDate.getDate() - 1);
      endDate.setDate(endDate.getDate() - 1);
      const start = format(startDate);
      const end = endFormat(endDate);
      this.dateRange = [start, end];
    },
    nextDay () {
      let startDate = this.dateRange && this.dateRange.length > 0
          ? new Date(this.dateRange[0])
          : new Date(); // 如果没选过，默认今天
      let endDate = this.dateRange && this.dateRange.length > 0
          ? new Date(this.dateRange[1])
          : new Date(); // 如果没选过，默认今天

      const format = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 00:00:00`;
      const endFormat = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 23:59:59`;

      startDate.setDate(startDate.getDate() + 1);
      endDate.setDate(endDate.getDate() + 1);
      const start = format(startDate);
      const end = endFormat(endDate);
      this.dateRange = [start, end];
    }
  },
  computed: {
    filteredProjectNames() {
      if (!this.projectNameFilter) return this.allProjectNames;
      return this.allProjectNames.filter(name => name.toLowerCase().includes(this.projectNameFilter.toLowerCase()));
    },
    pagedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.tableData.slice(start, start + this.pageSize);
    }
  }
}
</script>

<style scoped>

.center-table {
  text-align: center;
  
  font-size: 15px;
  color: #333;
}

.message-list-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  padding: 24px;
}
.header-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}
.action-btn {
  background-color: #fff;
  color: #444;
  border: 1px solid #dcdfe6;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}
.action-btn:hover {
  border-color: #40a9ff;
  color: #40a9ff;
}
.action-btn.danger {
  background-color: #ff4d4f !important;
  color: #fff !important;
  border-color: #ff4d4f !important;
}
.action-btn.danger:hover {
  background-color: #d9363e !important;
  border-color: #d9363e !important;
  color: #fff !important;
}
.message-list-container h2 {
  margin: 0 0 20px 0;
  font-size: 20px;
  color: #333;
}
.message-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}
.message-table th, .message-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
}
.message-table th {
  background: #f5f5f5;
  font-weight: 600;
  color: #333;
  text-align: center;
}
.message-table tr:hover {
  background: #f8fafc;
}
.filter-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
  flex-wrap: wrap;   /* ✅ 超出宽度自动换行 */
}

/* 移动端响应式样式 */
@media (max-width: 768px) {
  .filter-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  
  .filter-bar .el-input {
    width: 100%;
    max-width: 100% !important;
  }
  .filter-bar .el-select,
  .filter-bar .el-date-picker {
    width: 100% !important;
    margin-right: 0 !important;
  }
  
  .filter-bar .el-button {
    width: 100%;
    justify-content: center;
  }
  
  .header-actions {
    justify-content: center;
  }
  
  .header-actions .action-btn {
    width: 100%;
    justify-content: center;
  }
  
  .message-list-container {
    padding: 16px;
  }
  
  .message-list-container h2 {
    font-size: 18px;
    text-align: center;
  }
  
  /* 移动端表格横向滚动 */
  .center-table {
    font-size: 12px;
    overflow-x: auto;
    white-space: nowrap;
  }
  
  .center-table .el-table {
    min-width: 800px;
  }
  
  .center-table .el-table__header-wrapper th {
    padding: 8px 4px;
    font-size: 12px;
    white-space: nowrap;
  }
  
  .center-table .el-table__body-wrapper td {
    padding: 6px 4px;
    font-size: 12px;
    white-space: nowrap;
  }
  
  /* 分页器移动端优化 */
  .table-pagination-bar {
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
    overflow-x: auto;
    padding: 8px 0;
  }
  
  .table-pagination-bar .el-pagination {
    font-size: 12px;
    min-width: 300px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  
  /* 时间选择器移动端优化 */
  .el-date-editor.el-input {
    width: 100% !important;
  }
  
  .el-date-editor .el-range-input {
    font-size: 12px;
  }
  
  .el-date-editor .el-range-separator {
    font-size: 12px;
  }
  
  /* 确保时间选择器弹出框不超出屏幕 */
  .el-picker-panel {
    max-width: 90vw !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
  
  .el-date-range-picker {
    width: auto !important;
    min-width: 280px !important;
    max-width: 90vw !important;
  }
  
  .el-date-range-picker .el-picker-panel__content {
    width: auto !important;
  }
  
  .el-date-range-picker .el-date-range-picker__content {
    width: auto !important;
  }
}

/* 默认隐藏 */
.data-layout {
  display: none;
}

/* 屏幕宽度小于768px时（手机、微信内置浏览器常见宽度）显示 */
@media screen and (max-width: 768px) {
  .data-layout {
    display: flex;
  }
}

.table-pagination-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 8px;
  gap: 8px;
  width: 100%;
}
.table-count-bottom {
  color: #888;
  font-size: 15px;
  min-width: 180px;
  text-align: right;
}
.page-arrow {
  border: none;
  background: none;
  font-size: 18px;
  color: #42b983;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}
.page-arrow:disabled {
  color: #ccc;
  cursor: not-allowed;
  background: none;
}
.page-arrow:not(:disabled):hover {
  background: #e6f7f1;
}
.delete-confirm-box {
  min-width: 320px;
  max-width: 90vw;
  text-align: center;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  background: linear-gradient(135deg, #fff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
}

.delete-confirm-box h3 {
  color: #dc2626;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.delete-confirm-box h3::before {
  content: "⚠️";
  font-size: 24px;
}

.delete-confirm-content {
  font-size: 16px;
  margin: 20px 0 24px 0;
  color: #374151;
  line-height: 1.6;
  padding: 0 16px;
}

.delete-confirm-content b {
  color: #dc2626;
  font-weight: 600;
  background: #fef2f2;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #fecaca;
}

.dialog-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
  padding: 0 16px;
}

.dialog-actions .action-btn {
  min-width: 80px;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.dialog-actions .action-btn.danger {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  border-color: #dc2626;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
}

.dialog-actions .action-btn.danger:hover {
  background: linear-gradient(135deg, #b91c1c 0%, #991b1b 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);
}

.dialog-actions .action-btn:not(.danger) {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  color: #374151;
  border-color: #d1d5db;
}

.dialog-actions .action-btn:not(.danger):hover {
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.dialog-actions .action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.add-error {
  color: #dc2626;
  text-align: center;
  margin-top: 16px;
  font-size: 14px;
  padding: 8px 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  animation: shake 0.5s ease-in-out;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-4px); }
  75% { transform: translateX(4px); }
}
.dialog-mask {
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.dialog-box {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.13);
  padding: 32px 28px 24px 28px;
  min-width: 320px;
  max-width: 90vw;
}

/* 全局时间选择器样式 */
@media (max-width: 768px) {
  .el-picker-panel {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    max-width: 90vw !important;
    max-height: 80vh !important;
    overflow: auto !important;
    z-index: 9999 !important;
  }
  
  .el-date-range-picker {
    width: auto !important;
    min-width: 280px !important;
    max-width: 90vw !important;
  }
  
  .el-date-range-picker .el-picker-panel__content {
    width: auto !important;
  }
  
  .el-date-range-picker .el-date-range-picker__content {
    width: auto !important;
  }
  
  .el-date-range-picker .el-date-range-picker__body {
    min-width: 280px !important;
  }
}
</style> 